import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const FrozenShoulderPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Frozen Shoulder</h1>
        <section className="mb-8">
          <p>Frozen shoulder, also known as adhesive capsulitis, is a condition that causes pain and stiffness in the shoulder joint. Over time, movement becomes increasingly restricted, making daily activities difficult. While it can be frustrating, natural therapies can help restore mobility and reduce discomfort.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Injury or surgery leading to immobility</li>
            <li>Diabetes or thyroid disorders</li>
            <li>Age (more common after 40)</li>
            <li>Prolonged inactivity</li>
            <li>Inflammation of the shoulder capsule</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Gradual onset of shoulder pain</li>
            <li>Stiffness and limited range of motion</li>
            <li>Difficulty with overhead movements</li>
            <li>Pain worsening at night</li>
            <li>Weakness in the affected arm</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use herbal oils, gentle therapies, and guided exercises to reduce inflammation, relax muscles, and gradually restore movement. Our holistic care is tailored to each patient, focusing on both pain relief and functional recovery.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Non-invasive pain management</li>
            <li>Improves flexibility and strength</li>
            <li>Reduces inflammation naturally</li>
            <li>Personalized, gentle care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Perform regular shoulder stretches</li>
            <li>Apply warm compresses</li>
            <li>Practice gentle yoga</li>
            <li>Avoid sudden, forceful movements</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does frozen shoulder last?</strong>
            <p>A: With proper care, most people recover within months, though some stiffness may linger.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Can herbal treatment speed up recovery?</strong>
            <p>A: Yes, our approach can help reduce pain and restore movement more quickly.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Is this safe for seniors?</strong>
            <p>A: Absolutely, our therapies are gentle and suitable for all ages.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Regain your shoulder mobility—book a natural therapy session today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default FrozenShoulderPage; 